import { queryOptions } from '@tanstack/react-query'
import { fetchJson } from './client'
import type { AgeBand, StoryRequest } from './stories'
import type { LessonCard } from '@/schema/lessons'

export const lessonsQuery = (subject: string, ageBand: AgeBand) => queryOptions({
  queryKey: ['story-lessons', subject, ageBand],
  queryFn: ({ signal }) => fetchJson<{ items: LessonCard[] }>('/api/story-lessons', { query: { subject, age_band: ageBand }, signal }),
  staleTime: 60_000,
})

export interface StoryPreflight {
  status: 'ready' | 'needs_choice' | 'unsupported'
  objective: LessonCard | null
  props: { uid: string; name: string; count: number; source: 'prompt' | 'selected' | 'objective_suggestion' }[]
  cast_issues: { uid: string; message: string }[]
  notices: string[]
  capability_revisions: Record<string, string>
}
export function preflightStory(body: StoryRequest, signal?: AbortSignal): Promise<StoryPreflight> {
  return fetchJson('/api/stories/preflight', { method: 'POST', body, signal })
}
